import React from 'react';
import { DeliveryCalendar } from '../shared/calendar/DeliveryCalendar';
import { CHIP_HEX } from '../shared/calendar/calendarUtils';

export { toDayKey, spansDay } from '../shared/calendar/calendarUtils';

// Default palette — mirrors the Project Status Distribution used across Private Deliveries / Partner Conferences
export const STATUS_CALENDAR_COLORS = {
  completed: { chip: 'bg-green-500', label: 'Completed' },
  cancelled: { chip: 'bg-red-500', label: 'Cancelled' },
  in_progress: { chip: 'bg-blue-500', label: 'In Progress' },
  scheduled: { chip: 'bg-sky-500', label: 'Scheduled' },
  requested: { chip: 'bg-orange-500', label: 'Requested' },
  planning: { chip: 'bg-gray-400', label: 'Planning' },
};

/**
 * Status-coloured calendar.
 * items: [{ id, date, endDate?, title, statusKey, startTime?, endTime?, trainers?, pm?, client?, statusLabel? }]
 */
export const ProjectStatusCalendar = ({ items = [], statusColors = STATUS_CALENDAR_COLORS, onItemClick, testId = 'status-calendar-view' }) => {
  const events = items.map((it) => {
    const c = statusColors[it.statusKey];
    return {
      ...it,
      start: it.date,
      end: it.endDate,
      color: CHIP_HEX[c?.chip] || '#9CA3AF',
      statusLabel: it.statusLabel || c?.label || it.statusKey,
      onClick: onItemClick ? () => onItemClick(it) : undefined,
    };
  });
  const legend = Object.values(statusColors).map((v) => ({ label: v.label, color: CHIP_HEX[v.chip] || '#9CA3AF' }));
  return <DeliveryCalendar events={events} legend={legend} testId={testId} />;
};

export default ProjectStatusCalendar;
